<script lang="ts">
    import type { Newsletter } from '../../api/news.ts';
    import { push } from 'svelte-spa-router';
    import CaretRightIcon from '../../icons/CaretRightIcon.svelte';

    export let newsletter: Newsletter;
    export let image: string;

    function goToNewsletter() {
        push(`/Newsletters/${newsletter.id}?isInformational=${newsletter.isInformationalBroadcast}`);
    }
</script>

<div
    role="link"
    tabindex="0"
    on:click={goToNewsletter}
    on:keydown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            goToNewsletter();
        }
    }}
    class="group block w-full box-border cursor-pointer"
    aria-label="Newsletter: {newsletter.name}. Published {newsletter.getDisplayedDate()}. Click to read."
>
    <div
        class="flex flex-col md:flex-row border border-gray-300 bg-white overflow-hidden h-auto md:h-[170px] rounded-lg transition-all duration-300 ease-in-out group-hover:scale-[1.01] group-hover:shadow-lg group-hover:border-l-4 group-hover:border-l-[var(--vv-action-center-button-color,#0d9488)] group-focus:ring-2 group-focus:ring-[var(--vv-action-center-button-color,#0d9488)] group-focus:ring-offset-2"
        data-testid={`news-post-${newsletter.id}`}
    >
        <img
            src={image}
            alt={newsletter.name}
            class="w-full md:w-2/5 h-[140px] md:h-full object-cover flex-shrink-0"
            data-testid="image"
        />

        <div class="w-full md:w-3/5 p-4 md:p-5 flex flex-col justify-between" data-testid="content">
            <div class="flex flex-col gap-1">
                <p class="text-sm text-gray-500" data-testid="date">
                    {newsletter.getDisplayedDate()}
                </p>
                <h2 class="text-base md:text-lg font-semibold text-gray-900 leading-tight line-clamp-2" data-testid="headline">
                    {newsletter.name}
                </h2>
            </div>
            
            <!-- Read indicator -->
            <div class="flex items-center gap-1 text-sm text-gray-900 font-medium mt-2 md:mt-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span>Read newsletter</span>
                <CaretRightIcon color="currentColor" />
            </div>
        </div>
    </div>
</div>
